import { useRecoilState, useSetRecoilState } from "recoil"
import dayjs from "dayjs"
import {
  focusedItemIdxState,
  quizResponseListState,
} from "../../recoil/QuizPage/atoms"
import { QuizResponseType } from "../../types"

interface Props {
  itemId: number
  likert: number
  itemIdx: number
}

const useUpdateQuizResponse = () => {
  const [quizResponseList, setQuizResponseList] = useRecoilState(
    quizResponseListState
  )
  const setFocusedItemIdx = useSetRecoilState(focusedItemIdxState)

  const updateQuizResponse = ({ itemId, likert, itemIdx }: Props) => {
    let updatedResponseList: QuizResponseType[] = [...quizResponseList]
    updatedResponseList[itemIdx] = {
      item_id: itemId,
      likert: likert,
      response_time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    }

    console.log(updatedResponseList)
    console.log(itemId)
    setQuizResponseList(updatedResponseList)

    for (let i = itemIdx + 1; i < 20; i++) {
      if (!quizResponseList[i]) {
        setFocusedItemIdx(i)
        break
      }
    }
  }

  return { updateQuizResponse }
}

export default useUpdateQuizResponse
